export class ScheduleCountData{
    public frequency: string;
    public ends: boolean;
    public date: string;
    public occurrences: number;

    constructor(){
        this.frequency = "";
        this.ends = true;
        this.date = "";
        this.occurrences = 0;
    }

}